<template>
  <div class="edcity-add-school">
    <v-row>
      <v-col class="m-5">
        <v-text-field
          v-model="form.product_code"
          :label="labelHeader('product_code')"
          readonly
          disabled
        ></v-text-field>
        <v-text-field
          v-model="form.school_year"
          :label="labelHeader('school_year')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.passcode"
          :label="labelHeader('passcode')"
          required
          type="password"
        ></v-text-field>
        <p class="red--text font-weight-bold">{{ form.message }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="primary" @click="listProductSchoolByYear()">{{ $t("manage.by_edcity.list_product_schools.btn.list_product_schools") }}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-content>
            <v-data-table
              dense
              :headers="tableHeader()" 
              :items="api.edcity_product_schools" 
              item-key="school_code"
              :items-per-page="100">
              
            </v-data-table>
          </v-card-content>
        </v-card>
      </v-col>
    </v-row>
    <v-btn color="primary" @click="exportToCsv">
      {{ $t("manage.by_edcity.list_product_schools.btn.export_to_csv") }}
    </v-btn>

  </div>
</template>

<script>
import { api_edcity } from "@/services/dds/api_edcity";
const apiEdCity = new api_edcity(process.env.VUE_APP_BASE_URL);
export default {
  name: "ListProductSchool",
  data: function () {
    return {
      current: {
        username: null,
        uid: null,
        user_level: null,
        auth_token: null,
      },
      form: {
        product_code: "BL365",
        school_year: null,
        passcode: null,
        message: null,
      },
      api: {
        edcity_product_schools: [],
      },
      product_schools_header: [
        { text: 'Product Code', value: 'product_code' },
        { text: 'School Code', value: 'school_code' },
        { text: 'School Year', value: 'school_year' },
        { text: 'Status', value: 'status' },
        { text: 'Contact Name', value: 'school_contact_name' },
        { text: 'Contact Email', value: 'school_contact_email' },
        { text: 'Contact Mobile', value: 'school_contact_mobile' },
      ],
      product_schools_header_chi: [
        { text: '產品編號', value: 'product_code' },
        { text: '學校編號', value: 'school_code' },
        { text: '學校年份', value: 'school_year' },
        { text: '申請狀態', value: 'status' },
        { text: '聯絡人姓名', value: 'school_contact_name' },
        { text: '聯絡人電郵', value: 'school_contact_email' },
        { text: '聯絡人手機', value: 'school_contact_mobile' },
      ],
      selected_keys: [
        'product_code',
        'school_code',
        'school_year',
        'status',
        'school_contact_name',
        'school_contact_email',
        'school_contact_mobile'
      ],
    };
  },
  mounted: function () {
    var self = this;
    //self.current.school_id = self.$route.params.school_code;
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
  },  
  methods: {
    tableHeader(label){
      var self = this;
      if(self.$i18n.locale=='tc') return self.product_schools_header_chi;
      else return self.product_schools_header;
    },
    labelHeader(label){
      var self = this;
      if(label=="product_code") return self.$t("manage.by_edcity.list_product_schools.product_code");
      else if(label=="school_year") return self.$t("manage.by_edcity.list_product_schools.school_year");
      else if(label=="passcode") return self.$t("manage.by_edcity.list_product_schools.passcode");
    },
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    listProductSchoolByYear(){
      var self = this;
      
      apiEdCity.listProductSchoolByYear(self.form.school_year, self.form.passcode)
      .then((response) =>{
        if(response.status=="success"){
          self.api.edcity_product_schools = response.product_schools;
          self.$store.commit("showSnackBar", "Product chools are listed");
          self.form.message = null;
        }
        else if(response.status=="fail"){
          self.api.edcity_product_schools = [];
          self.form.message = response.message;
          self.$store.commit("showSnackBar", response.message);
        }
      });
    },
    jsonToCsv(jsonArray) {
      var self = this;      
      if (!jsonArray.length) return '';

      const selectedKeys = self.selected_keys;

      const csvRows = [
        selectedKeys.join(','), // Header row
        ...jsonArray.map(obj =>
          selectedKeys.map(key => {
            const val = obj[key] !== undefined && obj[key] !== null ? obj[key] : '';
            return `"${String(val).replace(/"/g, '""')}"`;
          }).join(',')
        )
      ];

      return csvRows.join('\n');
    },
    downloadCsv(filename, csvContent) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportToCsv() {
      var self = this;      
      const jsonData = self.api.edcity_product_schools; // Your JSON array
      if (!jsonData || jsonData.length === 0){
        self.$store.commit("showSnackBar", "No product schools are listed");
        return;
      }
      const csv = self.jsonToCsv(jsonData);
      self.downloadCsv('product_schools_'+Date.now()+'.csv', csv);
    }


  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>